<template>
  <div class="pt-2">
    <v-row dense>
      <v-col
        v-for="(compButton, index) in compButtons"
        :key="index"
        cols="4"
      >
        <v-btn
          :id="`add-${compButton.name.trim()}-button`"
          :data-testid="`add-${compButton.name.trim()}-button`"
          :disabled="disabledButtonTypes.includes(compButton.type)"
          :style="{ fontSize: compButtonFontSize }"
          block
          color="primary"
          variant="outlined"
          @click="handleButtonClick(compButton)"
        >
          <template #prepend>
            <v-icon
              color="secondary"
              :icon="getIcon(compButton)"
            />
          </template>
          <span class="text-secondary">{{ compButton.name }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {mapState} from 'vuex';

import {formatComps} from '@/lib/classes/InfoWindowContent/helpers/competitive';

export default {
  name: 'AddCompButtons',
  props: {
    disabledButtonTypes: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['linkPortfolio', 'addComp'],
  computed: {
    ...mapState('infowindow', [
      'shouldAddCompStandardFields',
      'compButtonFontSize',
      'compButtons',
      'showIcon',
    ]),
  },
  methods: {
    handleButtonClick(compButton) {
      // portfolios are handled separately from every other info window section comp type
      if (compButton.type === 'Portfolio') {
        this.$emit('linkPortfolio');
        return;
      }
      if (this.shouldAddCompStandardFields) {
        // Emit add comp with the new empty display fields comp
        this.$emit('addComp', formatComps([{type: compButton.type}], null)[0]);
      } else {
        const id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        this.$emit('addComp', {
          type: compButton.type,
          name: '',
          id,
          parent: null,
          displayFields: [],
        });
      }
    },
    getIcon(compButton) {
      if (!this.showIcon) return null;
      return compButton.icon || 'mdi-plus';
    },
  },
};
</script>

<style scoped>
/* Remove spacing between prepend icon and text for comp buttons */
:deep(.v-btn__prepend) {
  margin-inline-end: 0 !important;
}
</style>
